import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder,
         FormControl, Validators }  from '@angular/forms';

import { FieldManual } from './../../models/program/field-manual';
import { FmSettings } from './../../models/program/fm-settings';

@Component({
  selector: 'app-fm-settings',
  templateUrl: './fm-settings.component.html',
  styleUrls: ['./fm-settings.component.less']
})

export class FmSettingsComponent implements OnInit {
  @Input() fm: FieldManual;
  public settingsForm: FormGroup;

  constructor(private _fb: FormBuilder) { }

  ngOnInit() {

    // this.settingsForm = this._fb.group({
    //   title: [this.fm.title, <any>Validators.required],
    //   description: ['', <any>Validators.required],
    //   tags: ['', <any>Validators.required],
    //   cover_image: ['', <any>Validators.required],
    //   banner_image: ['', <any>Validators.required]
    // });

  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/fm-settings/fm-settings.component.ts